var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 123,
    height: 123,
    viewBox: "0 0 123 123",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "report 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M86.2729 2.01104L83.3413 0.2667C82.7628 -0.111909 81.99 -0.101579 81.1403 0.388979L35.5063 26.7357C33.7144 27.7704 32.2617 30.5458 32.2617 32.9352V118.429C32.2617 119.84 32.7689 120.801 33.5532 121.137L34.9389 121.979L36.1547 122.691L86.2729 2.01104Z",
    fill: "#667790"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M84.0504 96.2636L38.4165 122.61C36.6246 123.645 35.1719 122.547 35.1719 120.158V34.6642C35.1719 32.2748 36.6246 29.4994 38.4165 28.4647L84.0504 2.11792C85.8424 1.08323 87.295 2.18158 87.295 4.57071V90.0641C87.295 92.4535 85.8424 95.2292 84.0504 96.2636Z",
    fill: "#F7F8FB"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M80.2096 72.9847L45.4681 92.903C44.4599 93.4851 43.6426 95.0466 43.6426 96.391C43.6426 97.7353 44.4599 98.3532 45.4681 97.7711L80.2096 77.8528C81.2179 77.2707 82.0352 75.7092 82.0352 74.3648C82.0352 73.0205 81.2179 72.4026 80.2096 72.9847Z",
    fill: "#667790"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M60.7401 93.3577L45.4681 102.126C44.4599 102.708 43.6426 104.27 43.6426 105.614C43.6426 106.959 44.4599 107.576 45.4681 106.994L60.7401 98.2258C61.7483 97.6438 62.5656 96.0822 62.5656 94.7379C62.5656 93.3935 61.7483 92.7756 60.7401 93.3577Z",
    fill: "#667790"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M49.7541 41.8438L44.8242 44.6898V61.603L49.7541 58.757V41.8438Z",
    fill: "#003EB3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M57.2382 42.332L52.3086 45.1781V57.2818L57.2382 54.4358V42.332Z",
    fill: "#D3135A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M64.7245 41.0176L59.7949 43.8639V52.9616L64.7245 50.1155V41.0176Z",
    fill: "#F06292"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M72.2089 28.8809L67.2793 31.7269V48.6401L72.2089 45.7938V28.8809Z",
    fill: "#003EB3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M79.6933 17.2656L74.7637 20.1117V44.3191L79.6933 41.4731V17.2656Z",
    fill: "#5C93F8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M54.6983 64.392C55.7174 64.392 56.1813 66.1944 56.1813 67.8691C56.1813 72.1587 53.4506 77.4982 50.3376 79.2954C49.7956 79.6082 49.2847 79.7804 48.8984 79.7804C47.8793 79.7804 47.4151 77.9779 47.4151 76.3033C47.4151 72.0136 50.1459 66.6742 53.2589 64.877C53.8011 64.5642 54.3123 64.392 54.6983 64.392ZM54.6983 61.4707C53.8095 61.4707 52.8288 61.7523 51.7985 62.3473C47.7645 64.6762 44.4941 70.9249 44.4941 76.3035C44.4941 80.3084 46.3072 82.7021 48.8986 82.7021C49.7877 82.7021 50.7681 82.4206 51.7985 81.8255C55.8325 79.4965 59.1028 73.2482 59.1028 67.8693C59.1028 63.8642 57.2897 61.4707 54.6983 61.4707Z",
    fill: "#667790"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M59.1032 67.8691C59.1032 63.8642 57.2901 61.4707 54.6987 61.4707C53.8098 61.4707 52.8292 61.7523 51.7988 62.3473V65.9996C52.2694 65.5472 52.7593 65.166 53.2595 64.8772C53.8014 64.5644 54.3124 64.3922 54.6987 64.3922C55.7178 64.3922 56.1817 66.1947 56.1817 67.8693C56.1817 68.4437 56.1312 69.0374 56.039 69.6382L59.1032 67.8691Z",
    fill: "#F06292"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M75.1085 52.6791C76.1276 52.6791 76.5915 54.4815 76.5915 56.1562C76.5915 60.4458 73.8607 65.7853 70.7478 67.5825C70.2058 67.8953 69.6948 68.0675 69.3085 68.0675C68.2894 68.0675 67.8253 66.265 67.8253 64.5904C67.8253 60.3007 70.556 54.9613 73.669 53.1641C74.2112 52.8516 74.7224 52.6791 75.1085 52.6791ZM75.1085 49.7578C74.2196 49.7578 73.239 50.0394 72.2086 50.6344C68.1746 52.9633 64.9043 59.212 64.9043 64.5906C64.9043 68.5956 66.7173 70.9893 69.3088 70.9893C70.1979 70.9893 71.1783 70.7077 72.2086 70.1126C76.2426 67.7836 79.5129 61.5353 79.5129 56.1565C79.5129 52.1513 77.6999 49.7578 75.1085 49.7578Z",
    fill: "#667790"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M75.1088 49.7578C74.22 49.7578 73.2393 50.0394 72.209 50.6344V54.2867C72.6796 53.8344 73.1697 53.4531 73.6698 53.1643C74.2118 52.8516 74.7228 52.6793 75.1091 52.6793C76.1282 52.6793 76.5921 54.4818 76.5921 56.1565C76.5921 59.7569 74.668 64.096 72.209 66.4603V70.1126C76.243 67.7836 79.5133 61.5353 79.5133 56.1565C79.5133 52.1513 77.7003 49.7578 75.1088 49.7578Z",
    fill: "#003EB3"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M94.9149 95.8427C95.8499 96.7871 97.1462 97.3733 98.5804 97.3733C101.429 97.3733 103.739 95.0637 103.739 92.2147C103.739 90.8341 103.193 89.5832 102.31 88.6573L102.312 88.6554L97.9298 84.2961C97.8767 84.2339 97.8222 84.1729 97.7665 84.1133L91.6621 92.5876L94.9146 95.8432L94.9149 95.8427Z",
    fill: "#5C93F8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M101.82 68.4783C101.82 63.0507 100.118 59.1361 97.3869 57.2428L97.3862 57.2423C97.0438 57.0052 96.6849 56.8 96.3113 56.6273L92.4849 54.4381C89.974 52.9683 86.6909 53.0949 83.098 55.1693C75.2063 59.7256 68.8086 71.9495 68.8086 82.4717C68.8086 88.1213 70.6534 92.1303 73.583 93.928L73.5833 93.9283C73.7356 94.0217 77.9877 96.4173 77.9877 96.4173C80.5179 97.9861 83.8629 97.8986 87.5313 95.7807C88.9676 94.9514 90.3543 93.867 91.6621 92.5861L97.7664 84.1118C100.274 79.231 101.82 73.6494 101.82 68.4783Z",
    fill: "#131416"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M87.6582 88.5727L94.9457 81.2852L97.6719 84.0113L97.6714 84.0118C98.5922 84.9437 99.1618 86.2234 99.1618 87.637C99.1618 90.4859 96.8522 92.7955 94.0033 92.7955C92.6803 92.7955 91.4775 92.2932 90.5643 91.4745L90.5622 91.4769L87.6582 88.5727Z",
    fill: "#85AFFB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M73.2422 84.9782C73.2422 95.5005 79.6396 100.337 87.5316 95.7806C95.4235 91.224 101.821 79.0004 101.821 68.4782C101.821 57.9559 95.4235 53.1193 87.5316 57.6758C79.6396 62.2323 73.2422 74.4557 73.2422 84.9782Z",
    fill: "#272C34"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M77.6758 82.4182C77.6758 89.6757 82.0884 93.0116 87.5314 89.8691C92.9744 86.7265 97.387 78.2955 97.387 71.0378C97.387 63.7803 92.9744 60.4444 87.5314 63.5869C82.0884 66.7294 77.6758 75.1605 77.6758 82.4182Z",
    fill: "#B6CEFB"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    opacity: 0.2,
    d: "M77.6758 82.4203C77.6758 80.2281 78.0789 77.9293 78.7907 75.7012L92.0879 85.7538C90.7251 87.4897 89.1753 88.922 87.5314 89.8712C86.3557 90.5498 85.2283 90.9258 84.1828 91.026L78.2595 86.548C77.8821 85.372 77.6758 83.9878 77.6758 82.4203Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    opacity: 0.2,
    d: "M87.5308 63.5886C88.6664 62.933 89.7566 62.5604 90.7716 62.4453L96.8404 67.0333C97.1937 68.1828 97.3864 69.5253 97.3864 71.0392C97.3864 74.5445 96.357 78.3234 94.6792 81.6482L80.7461 71.1151C82.5133 67.858 84.9017 65.1064 87.5308 63.5886Z",
    fill: "white"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReport);
export default __webpack_public_path__ + "static/media/report.9c3ddc4d1544738e333bdbee54a2e72a.svg";
export { ForwardRef as ReactComponent };